<template>
  <div class="application-policy-container">
    <div class="company-application">
      <h1 class="b-1-cl title a-5-bg">{{ $t("application.policy.title") }}</h1>
      <div>
        <p
          class="b-1-cl desc a-5-bg"
          v-html="$t('application.policy.desc')"
        ></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ApplicationPolicy',
};
</script>

<style lang="scss" scoped>
.application-policy-container {
  .company-application {
    font-weight: 100;
    text-align: left;
    width: 100%;
    margin: 30px auto 0;

    .title {
      font-size: 22px;
      font-weight: 100;
      height: 100px;
      line-height: 100px;
      padding-left: 50px;
      padding-right: 60px;
      margin-bottom: 23px;
    }

    .desc {
      font-size: 14px;
      line-height: 24px;
      padding: 40px 63px 59px 62px;
    }
  }
}
</style>
